import { renderCardFound } from './renderTemplates';
/* global google */
/* global markerClusterer */



let map;
let autocomplete;
let centerMarker;
let storeMarkers = [];
let searchCircle;
let globalLocation = null;
let geocoder;
let fromCountry = false;
let place;
let initCountry = true;
let infoWindow;
let markerCluster;
let onlyCountry = null;
let currentInfoWindow = null;
let directionsService;
let directionsRenderer;
let directionContainer;
let autocompleteInfoWindow;
let geoActive = null;
let alreadySearchGoogleInput = false
let firstTime = true;
let clearAllBtn = false;
let countryName = null;
let radioGuat = null;
let searchOnlyState = null;
let stateName = null;
let searchPrevInCountrySection = false;
/**
 *
 * @param {Object} destLat - Latitude de destino
 * @param {Object} destLng - Longitud de destino
 * @param {Object} locationPartida - Informacion de origen
 */
function calculateAndDisplayRoute(destLat, destLng, locationPartida) {
    const selectedMode = document.querySelector(
        'input[name="transport-mode"]:checked'
    ).value;
    const request = {
        origin: locationPartida,
        destination: { lat: destLat, lng: destLng },
        travelMode: google.maps.TravelMode[selectedMode]
    };

    directionsService.route(request, function (response, status) {
        if (status === 'OK') {
            directionsRenderer.setDirections(response);

            const route = response.routes[0];
            const distance = route.legs[0].distance.text;
            const duration = route.legs[0].duration.text;

            // const infoWindowContent = document.getElementById(containerId);
            // const distanceInfo = infoWindowContent.querySelector('.distance-info');
            // distanceInfo.innerHTML = `<p>Distancia: ${distance}</p><p>Tiempo estimado: ${duration}</p>`;

            // infoWindow.setContent(infoWindowContent);
        }
    });
}

/**
 * Funcion para salir de la vista street view
 *@param {bool} funcion que sirve para cerrar el street view
 */
function exitStreetView() {
    try {
        map.setStreetView(null);
    } catch (error) {
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 5,
            center: globalLocation
        });
        map.setStreetView(null);
    }
    document.getElementById('exit-street-view').style.display = 'none';
}

/**
 *
 * @param {Object} latitude - Informacion de la tienda
 * @param {Object} longitude - Informacion de la tienda
 */
function initInputPlacesInfoWindow(latitude, longitude) {
    let desLat = latitude;
    let destLng = longitude;
    let partida = autocompleteInfoWindow.getPlace();
    let locationPartida;
    if (partida.geometry) {
        // Actualizar las variables globales
        locationPartida = {
            lat: partida.geometry.location.lat(),
            lng: partida.geometry.location.lng()
        };
    }
    calculateAndDisplayRoute(desLat, destLng, locationPartida);
}


/**
 * 
 *@param {Object} data - Informacion de la tienda
 *@returns {template} Retorna template para infoeWindow
 */
function contentInfoWindow(data) {
    $('#map').spinner().start();
    const templateInfoWindow = `
        <div class="card-container-stores mb-4">
            <h3 class="card-cointainer__title pt-2 pb-2 pl-2">${data.name}</h3>
            <div class="card-container__body d-flex flex-column pl-2">
                <p>${data.address1} ${data.numExt ? '#' + data.numExt : ""} ${data.numInt ? data.numInt : ""} ${data.nombreColonia ? data.nombreColonia : ""} C.P ${data.postalCode} ${data.city ? data.city : ""}, ${data.stateCode ? data.stateCode : ""}</p>
                <p>${data.horarioTienda ? data.horarioTienda : ""} ${data.telefonos ? data.telefonos : ""}</p>
                <div class="body-container-locations d-flex justify-content-end">
                    <div class="body-container-locations__links d-flex flex-nowrap flex-sm-wrap justify-content-sm-end flex-md-nowrap">
                        <a href="javascript:void(0)" class="link-gray mr-2 mr-sm-0 mr-md-2" onclick="showStreetView(${data.latitude}, ${data.longitude}, &quot;${data.storeUrlStreet}&quot;)">Street view</a>
                        <a href="javascript:void(0)" class="link-blue ${data.storeUrl360 ? '' : 'd-none'}" onclick="showStoreUrl360(&quot;${data.storeUrl360}&quot;)">Recorre la tienda</a>
                    </div>
                </div>
                <div class="direction-container mt-2">
                    <div class="transport-options d-flex justify-content-around">
                        <label class="transport-option">
                            <input type="radio" name="transport-mode" value="DRIVING" checked>
                            <span class="material-symbols-outlined" data-mode="DRIVING">directions_car</span>
                        </label>
                        <label class="transport-option">
                            <input type="radio" name="transport-mode" value="WALKING">
                            <span class="material-symbols-outlined" data-mode="WALKING">directions_walk</span>
                        </label>
                        <label class="transport-option">
                            <input type="radio" name="transport-mode" value="TRANSIT">
                            <span class="material-symbols-outlined" data-mode="TRANSIT">directions_bus</span>
                        </label>
                        <label class="transport-option">
                            <input type="radio" name="transport-mode" value="BICYCLING">
                            <span class="material-symbols-outlined" data-mode="BICYCLING">directions_bike</span>
                        </label>
                    </div>
                    <div class="origin-destination w-100 d-flex content-justify-center">
                        <div class="icons-to-go d-flex flex-column">
                            <span class="material-symbols-outlined">
                                trip_origin
                            </span>
                            <span class="material-symbols-outlined">
                                go_to_line
                            </span>
                            <span class="material-symbols-outlined">
                                location_on
                            </span>
                        </div>
                        <div class="input-container d-flex flex-column w-100">
                            <input type="text" id="origin-input" class="input-origin mb-1" placeholder="Origen">
                            <input type="text" id="destination-input" data-latDest="${data.latitude}" data-longDest="${data.longitude}" class="input-origin mt-1" value="${data.name} - ${data.address1}" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    return templateInfoWindow;
}
// Añadir manejador de eventos para los iconos
document
    .querySelectorAll('.transport-option .material-symbols-outlined')
    .forEach((icon) => {
        icon.addEventListener('click', function () {
            const mode = this.getAttribute('data-mode');
            document.querySelector(
                `input[name="transport-mode"][value="${mode}"]`
            ).checked = true;
        });
    });

// Obtener una referencia al campo de entrada por su ID
let desLat;
let destLng;
/**
 * appends params to a url
 * @param {Object} response - Respuesta por parte del controlador
 * @param {string} typeStore - tipo de tienda o seleccion
 * @param {boolean} storeNotFound - dato para saber que template mostrar
 */
function updateTitleStoresFound(response, typeStore, storeNotFound) {
    let strAdds = response.countStores == 1 ? '' : 's';
    let strTodos = response.countStores == 1 ? '' : 'es';
    $('.wrapper-found-store').each(function () {
        let h2Element = $(this).find('h2');
        if (h2Element.length > 0) {
            if (typeStore.toString().toLowerCase() === 'store') {
                h2Element.text(
                    `Encontramos ${response.countStores} tienda${strAdds}`
                );
            } else if (typeStore.toString().toLowerCase() === 'cedis') {
                h2Element.text(
                    `Encontramos ${response.countStores} centro${strAdds} de distribución`
                );
            } else {
                h2Element.text(
                    `Encontramos ${response.countStores} sucursal${strTodos}`
                );
            }
        }
    });
    if (storeNotFound) {
        $('.cards-container__store-not-found').each(function () {
            $(this).removeClass('d-none');
        });
    } else {
        $('.cards-container__store-not-found').each(function () {
            $(this).addClass('d-none');
        });
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');

    return newUrl;
}
/**
 * funcion que devuelve el tipo de request, tienda, cedis o todos
 * @returns {string} tipo de tienda o todas
 */
function getTypeReq() {
    let typeReq = null;
    // Selecciona todos los botones
    const buttons = document.querySelectorAll(
        '.button-search-store, .button-search-cedis, .button-search-all'
    );

    // Recorre cada botón y verifica si tiene la clase 'active'
    buttons.forEach((button) => {
        if (button.classList.contains('active')) {
            typeReq = button.dataset.type;
        }
    });

    return typeReq;
}
/**
 * Limpia todos los marcadores de tiendas del mapa
 */
function clearStoreMarkers() {
    if (window.markerCluster) {
        window.markerCluster.clearMarkers(); // Limpiar los marcadores del cluster
    }
    storeMarkers.forEach((marker) => marker.setMap(null)); // Quitar los marcadores del mapa
    storeMarkers = []; // Reiniciar el array de marcadores
}


/**
 * Función que muestra los marcadores de las tiendas en el mapa
 * @param {Array} storesFound - Array de tiendas encontradas
 */
function showStoresInMap(storesFound) {
    // Detectar si hay streetview abierto
    let elementStreetview = document.getElementById('exit-street-view');
    if (elementStreetview.style.display === 'block') {
        exitStreetView();
    }

    clearStoreMarkers(); // Limpiar los marcadores existentes    

    const icons = {
        tienda: {
            url: $('#imageMarker').val(),
            scaledSize: new google.maps.Size(30, 30) // Tamaño del ícono en píxeles
        },
        cedis: {
            url: $('#imageMarkerCedis').val(),
            scaledSize: new google.maps.Size(30, 30) // Tamaño del ícono en píxeles
        }
    };

    const newStoreMarkers = []; // Array temporal para los nuevos marcadores

    storesFound.forEach((store) => {
        const icon = icons[store.tipoSucursal.toLowerCase()];
        const position = { lat: store.latitude, lng: store.longitude };
        const storeMarker = new google.maps.Marker({
            position: position,
            map: map,
            icon: {
                url: icon.url,
                scaledSize: icon.scaledSize
            }
        });

        const template = contentInfoWindow(store);

        google.maps.event.addListener(storeMarker, 'click', function () {
            $('#map').spinner().start();
            // Cerrar el InfoWindow actual si existe
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }

            // Crear nuevo InfoWindow
            currentInfoWindow = new google.maps.InfoWindow({
                content: template,
                position: position,
                pixelOffset: new google.maps.Size(0, -40) // Ajusta el valor según sea necesario
            });

            // Abrir el nuevo InfoWindow
            currentInfoWindow.open(map);

            // Centrar y hacer zoom en la ubicación del marcador
            map.setCenter(position);
            map.setZoom(15); // Ajusta el nivel de zoom según sea necesario

            // Inicializar Autocomplete después de que el contenido del InfoWindow esté disponible en el DOM
            setTimeout(() => {
                let originInput = document.getElementById('origin-input');
                autocompleteInfoWindow = new google.maps.places.Autocomplete(originInput);
                autocompleteInfoWindow.addListener('place_changed', () =>
                    initInputPlacesInfoWindow(store.latitude, store.longitude)
                );

                const element = document.querySelector('.gm-style-iw-d');
                if (element) {
                    const maxHeight = element.style.maxHeight;
                    if (maxHeight) {
                        element.style.maxHeight = '';
                        element.style.height = '300px';
                    }
                }

                $.spinner().stop();
            }, 500);
        });

        // Agregar el marcador al array de marcadores temporales
        newStoreMarkers.push(storeMarker);
    });

    // Limpiar y actualizar el MarkerClusterer si está definido
    if (window.markerCluster) {
        window.markerCluster.clearMarkers(); // Limpiar los marcadores del cluster
    }

    // Crear el MarkerClusterer con los nuevos marcadores
    window.markerCluster = new markerClusterer.MarkerClusterer({ map, markers: newStoreMarkers });

    // Actualizar la lista global de marcadores de tiendas
    storeMarkers = newStoreMarkers;
}



/**
 * Actualiza el círculo de búsqueda en el mapa
 * @param {Object} center - Centro del círculo (lat y lng)
 * @param {number} radius - Radio del círculo en kilómetros
 * @param {boolean} notFound - Indica si no se encontraron tiendas
 * @param {boolean} deleteCircle - Indica si se debe eliminar el círculo existente
 */
function updateSearchCircle(center, radius, notFound, deleteCircle) {
    /**
    // Formacion del objeto de circulo
    */
    function initCircle() {
        let color = notFound ? '#FF0000' : '#818181';
        searchCircle = new google.maps.Circle({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
            map: map,
            center: center,
            radius: radius * 1000 // Convertir kilómetros a metros
        });
    }
    // Eliminar el círculo existente si existe
    let bounds;
    if (searchCircle) {
        searchCircle.setMap(null); // Elimina el círculo existente del mapa
        searchCircle = null;
    }

    // Si se debe eliminar el círculo existente y no crear uno nuevo
    if (deleteCircle || fromCountry) {
        return;
    }

    if(!fromCountry){
        initCircle();
    }
    // Ajustar el zoom del mapa para que se adapte al círculo
    bounds = searchCircle.getBounds();
    try {
        map.fitBounds(bounds);
    } catch (error) {
        map = new google.maps.Map(document.getElementById('map'), {
            center: center
        });
        centerMarker = new google.maps.Marker({
            position: center,
            map: map
        });
        searchCircle.map = map;
        initCircle();
        bounds = searchCircle.getBounds();
        map.fitBounds(bounds);
    }
}
/**
 * funcion que llama servicio de getTiendas y las pinta en el mapa
 * @param {Object} location recibe parametro con lat y lng
 * @param {string} typeStore tipo de boton seleccionado
 * @param {boolean} startValue es primera vez o no
 * @param {string} storeNameReq Nombre pasado por paramtro para buscar la tienda
 * @param {boolean} geoActiveParam Identifica si fue usuario con geolocation desde que entro a la pagina
 */
function getStores(location,typeStore,startValue,storeNameReq,geoActiveParam) {
    let url = $('#get-all-stores').val();
    let radius;
    if(radioGuat) {
        radius = 150;
    } else if (searchOnlyState) {
        radius = 600
    } else if (startValue && !fromCountry && !geoActiveParam || storeNameReq || onlyCountry) {
        radius = 3000;
    } else if (fromCountry) {
        radius = 50;
    } else {
        radius = $('#kmSlider').val();
    }
    // Check if centerMarker exists and remove it from the map
    if (centerMarker) {
        centerMarker.setMap(null);
        centerMarker = null; // Set centerMarker to null after removing it
    }
    // Set centerMarker with zoom adjustment
    centerMarker = new google.maps.Marker({
        position: location,
        map: map,
        zoom: startValue ? 30 : 15 // Adjust zoom level here
    });

    // Cerrar el InfoWindow actual si existe
    if (currentInfoWindow) {
        currentInfoWindow.close();
    }

    let urlParams = {
        lat: location.lat,
        long: location.lng,
        radius: radius,
        typeStore: typeStore,
        storeNameReq: storeNameReq,
        onlyCountry: onlyCountry,
        countryName: countryName,
        onlyState: searchOnlyState,
        stateName: stateName
    };

    // Update the search circle only if not starting value or from country
    if (!startValue || geoActive || fromCountry) {
        updateSearchCircle(location, radius);
    }
    if (fromCountry) updateSearchCircle(null, null, null, true);
    $('body').spinner().start();
    $.ajax({
        url: url,
        data: urlParams,
        type: 'POST',
        success: function (response) {
            if (
                response &&
                response.storesObj &&
                response.storesObj.length > 0
            ) {
                showStoresInMap(response.storesObj);
                // Actualización del título
                updateTitleStoresFound(response, typeStore);
                // Limpiar y renderizar las tarjetas de tiendas
                $('.found-stores-container__cards-container').empty();
                response.storesObj.forEach(function (store) {
                    let templateRender = renderCardFound(store);
                    $('.found-stores-container__cards-container').append(
                        templateRender
                    );
                });
                if (storeNameReq) {
                    fromCountry = true;
                    map.setZoom(5);
                }
                if(fromCountry && !storeNameReq) {
                    map.setZoom(8)
                }
                if (response.onlyCountry || response.onlyState) {
                    var bounds = new google.maps.LatLngBounds();
                    storeMarkers.forEach(function(marker) {
                        bounds.extend(marker.getPosition());
                        map.fitBounds(bounds);
                    })
                }
            } else if (response && response.countStores == 0) {
                $('.found-stores-container__cards-container').empty();
                // Limpiar los marcadores individuales
                storeMarkers.forEach(marker => marker.setMap(null));
    
                // Limpiar el cluster de marcadores si está definido
                if (window.markerCluster) {
                    window.markerCluster.clearMarkers();
                }

                // Reiniciar el array de marcadores
                storeMarkers = [];
                if (!fromCountry)
                    updateSearchCircle(
                        location,
                        radius,
                        true,
                        startValue && !geoActive ? true : null
                    );
                updateTitleStoresFound(response, typeStore, true);
                if (storeNameReq) {
                    fromCountry = true;
                    map.setCenter(globalLocation)
                    if(fromCountry) {
                        map.setZoom(5)
                    }
                }
            }
            $.spinner().stop();
        },
        error: function (error) {
            $.spinner().stop();
        }
    });
}

/** funcion to get information used an event
* @param {string} components array element 
* @param {string} type could be locality, country or administrative_area_level_1
* @returns {component} value
*/
function getLongNameByType(components, type) {
    const foundComponent = components.find(item => item.types.includes(type));
    return foundComponent ? foundComponent.long_name : '';
}

/**
 * funcion to send an event
 * @param {string} addressComponents array element 
 */
function eventGetLocalization (addressComponents) {
    const localityLongName = getLongNameByType(addressComponents, 'locality');
    const countryLongName = getLongNameByType(addressComponents, 'country');
    const adminAreaLevel1LongName = getLongNameByType(addressComponents, 'administrative_area_level_1');
    window.dataLayer.push({
        'event': 'locate_store',
        'store_preference' : 'Por dirección',
        'store_country': countryLongName,
        'store_state': adminAreaLevel1LongName,
        'store_city': localityLongName,
        'store_name' : ""
    });
}

/**
 * funcion que maneja la data del input de autocomplete
 * @param {string} param tipo de boton seleccionado
 */
function searchByInputGoogle(param) {
    place = autocomplete.getPlace();
    if (place && place.geometry && !param) {  
        // Actualizar las variables globales
        globalLocation = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        };
        try {
            map.setCenter(place.geometry.location);
            map.setZoom(15);
        } catch (error) {
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: 15,
                center: globalLocation
            });
        }
        // Llamar a getStores con las variables actualizadas
        fromCountry = false;
        alreadySearchGoogleInput = true;
        getStores(globalLocation, getTypeReq(), null);
    } else if(param || (place && place.name)) {
        let address = param || place.name;
        if (param && param.toLowerCase() === 'guatemala') {
            address = param + ', Ciudad de ' + param;
        }
        geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address}, function (results, status) {
            if (status == 'OK') {
                // Actualizar las variables globales
                globalLocation = {
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng()
                };
                try {
                    map.setCenter(results[0].geometry.location);
                    map.setZoom(15);
                } catch (error) {
                    map = new google.maps.Map(document.getElementById('map'), {
                        zoom: 15,
                        center: globalLocation
                    });
                }
                // Llamar a getStores con las variables actualizadas
                fromCountry = false;
                alreadySearchGoogleInput = true;
                getStores(globalLocation, getTypeReq(), null);
            }
        });
    }
}

$('#autocomplete').on('focus', function () {
    $('#errorMessageInputGoogle').hide();
});

$('#autocomplete').on('keydown', function(event) {
    if (event.key === 'Enter') {
        event.preventDefault(); // Evita el comportamiento predeterminado del navegador (si es necesario)
        $('#search-address-search').trigger('click'); // Dispara el evento de clic en #search-address-search
    }
});

$('#search-address-search').on('click', function (e) {
    e.preventDefault();
    let inputVal = $('#autocomplete').val().trim();

    if (inputVal === "") {
        $('#errorMessageInputGoogle').show();
        return;
    }
    if (place) {
        searchByInputGoogle();
        var addressComponents = place.address_components;
        eventGetLocalization(addressComponents);
    } else if ($('#autocomplete').val() && $('#autocomplete').val() !== '') {
        searchByInputGoogle($('#autocomplete').val());
    }
});

/**
 * funcion para obtener la ubicacion del usuario
 * @returns {Object} position del usuario
 */
function getCurrentLocation() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const userPosition = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                resolve(userPosition);
            },
            (error) => {
                reject(error);
            }
        );
    });
}
/**
 * funcion que maneja la longitud y latitud
 * @param {Object} userPosition latitud y longitud
 * @returns {Object} objeto de google geocoder
 */
function reverseGeocodeLocation(userPosition) {
    geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
        geocoder.geocode({ location: userPosition }, function (results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    resolve(results[0]);
                } else {
                    reject(new Error('No se encontraron resultados'));
                }
            } else {
                reject(new Error('Geocoder falló debido a: ' + status));
            }
        });
    });
}

/**
 * funcion que maneja la data del input de autocomplete
 * @param {atributoDeObjet0} addressComponents tipo de boton seleccionado
 * @returns {string} city and country
 */
function getStateAndCity(addressComponents) {
    let state = '';
    let city = '';

    addressComponents.forEach(component => {
        if (component.types.includes('administrative_area_level_1')) {
            state = component.long_name;
        }
        if (component.types.includes('locality')) {
            city = component.long_name;
        }
    });

    return { state, city };
}


/**
 * funcion que maneja la data del input de autocomplete
 * @param {string} cookieValue tipo de boton seleccionado
 */
function initMapWithLocalization (cookieValue){
    /**
    * funcion que maneja la data del input de autocomplete
    * @param {Object} address objecto con direccion
    * @returns {Promise} retorna una promesa
    */
    function geocodeAddress(address) {
        return new Promise((resolve, reject) => {
            geocoder.geocode({ address: address }, function (results, status) {
                if (status === 'OK') {
                    resolve(results);
                } else {
                    reject(status);
                }
            });
        });
    }

    try {
        const objMunicipios = cookieValue;
        // Manejar las propiedades del objeto
        const lngltg = {
            estado: objMunicipios.ESTADO,
            nombre: objMunicipios.NOMBRE
        };
        geocoder = new google.maps.Geocoder();
        var address = `${lngltg.estado} ${lngltg.nombre}`;

        geocodeAddress(address).then(results => {
            // Limpiar marcadores anteriores
            clearStoreMarkers();
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: 2,
                center: results[0].geometry.location
            });

            // clearStoreMarkers();

            if (centerMarker) {
                centerMarker.setMap(null);
            }
            if (searchCircle) {
                updateSearchCircle(null, null, null, true);
            }
            const formattedAddress = results[0].formatted_address;
            setTimeout(()=> {
                let inputGoogle = document.getElementById('autocomplete');
                if(inputGoogle) {
                    inputGoogle.value = formattedAddress;
                    geoActive = true;
                    searchByInputGoogle(inputGoogle.value);
                }
            },1300)
            // globalLocation = results[0].geometry.location;
        }).catch(error => {
            // En caso de error, usar la ubicación global
            globalLocation = {
                lat: 24.19062908764244,
                lng: -102.85224768231377
            };
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: 2,
                center: globalLocation
            });
            getStores(globalLocation, getTypeReq(), true);
        });
    } catch (e) {
        globalLocation = {
            lat: 24.19062908764244,
            lng: -102.85224768231377
        };
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 2,
            center: globalLocation
        });
        fromCountry = false;
        getStores(globalLocation, getTypeReq(), true);
    }
}

/**
 * Funcion principal inicio
 */
function initMap() {
    let confirmLocation = document.getElementById('get-confirm-location');
    infoWindow = new google.maps.InfoWindow();
    // Inicialización de directionsService y directionsRenderer
    directionsService = new google.maps.DirectionsService();
    directionsRenderer = new google.maps.DirectionsRenderer();
    
    /**
    * funcion que maneja la data del input de autocomplete
    * @param {string} name nombre de la cookie
    * @return {Object} cook objet locations
    */
    function getCookie(name) {
        let cook;
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) cook = parts.pop().split(';').shift();
        return cook;
    }

    // Obtener la cookie 'dataUserObtenerMunicipios'
    let cookieValue = getCookie('dataUserObtenerMunicipios');
    let decodedValue = decodeURIComponent(cookieValue);
    let objCookie = JSON.parse(decodedValue);

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if (params.has('lat') && params.has('lng')) {
        let latitude; let longitude; let typeValue = "all";

        latitude = params.get('lat');
        longitude = params.get('lng');

        if (params.has('type')) {
            typeValue = params.get('type');
        }

        globalLocation = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 15,
            center: globalLocation
        });
        clearAllBtn = true;
        geoActive = false;
        getStores(globalLocation, typeValue, true);
    } else if (cookieValue && !clearAllBtn && objCookie && objCookie.CONFIRM_LOCATION && objCookie.CONFIRM_LOCATION == true) {
        initMapWithLocalization(objCookie);
    } else {
        navigator.permissions.query({ name: 'geolocation' }).then(function(result) {
            if (result.state === 'granted') {
                getCurrentLocation()
                    .then(userPosition => {
                        return reverseGeocodeLocation(userPosition);
                    })
                    .then(results => {
                        let address = results
                        clearStoreMarkers();
                        map = new google.maps.Map(document.getElementById('map'), {
                            zoom: 2,
                            center: results.geometry.location
                        });
                        if (centerMarker) {
                            centerMarker.setMap(null);
                        }
                        if (searchCircle) {
                            updateSearchCircle(null, null, null, true);
                        }
                        const { state, city } = getStateAndCity(address.address_components);
                        clearAllBtn = true;
                        setTimeout(()=> {
                            let inputGoogle = document.getElementById('autocomplete');
                            if(inputGoogle) {
                                inputGoogle.value = `${city}, ${state}`;
                                geoActive = true;
                                searchByInputGoogle(inputGoogle.value);
                            }
                        },800)
                    })
                    .catch(error => {
                        // eslint-disable-next-line no-console
                        console.error('Error:', error);
                    });
            } else if (result.state === 'prompt' || result.state === 'denied') {
                // En caso de que no se otorgue el permiso, usar ubicación por defecto
                globalLocation = {
                    lat: 24.19062908764244,
                    lng: -102.85224768231377
                };
                map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 2,
                    center: globalLocation
                });
                clearAllBtn = false;
                geoActive = false;
                getStores(globalLocation, getTypeReq(), true);
            }
        });
    }
    directionsRenderer.setMap(map); // Asociar directionsRenderer con el mapa
}


// Llamada ajax para input de google
var input = document.getElementById('autocomplete');
// input.value = '';
autocomplete = new google.maps.places.Autocomplete(input);
autocomplete.addListener('place_changed', searchByInputGoogle);
// Llamada ajax para input de google
/**
 * Funcion para activar vistas de busqueda
 * @param {bool} param tipo de boton seleccionado
 */
function activateStore(param) {
    fromCountry = true;
    initCountry = param;
    $('#btn-store')
        .removeClass('btn-outline-secondary-custom')
        .addClass('btn-primary');
    $('#btn-address')
        .removeClass('btn-primary')
        .addClass('btn-outline-secondary-custom');
    $('.country-search').removeClass('d-none').addClass('d-flex');
    $('.address-search').addClass('d-none').removeClass('d-flex');
    if(alreadySearchGoogleInput || firstTime){
        $('#select-country').val('mexico').change();
        $('#alcaldia').val("")
        $('#input-store-name').val('');
    }
}
/**
 * Funcion para activar la seccion de seleccion por direccion.
 *@param {bool} param tipo de boton seleccionado
 */
function activateAddress(param) {
    fromCountry = false;
    initCountry = param;
    $('#btn-address')
        .removeClass('btn-outline-secondary-custom')
        .addClass('btn-primary');
    $('#btn-store')
        .removeClass('btn-primary')
        .addClass('btn-outline-secondary-custom');
    $('.address-search').removeClass('d-none').addClass('d-flex');
    $('.country-search').addClass('d-none').removeClass('d-flex');
    $('#errorMessageInputGoogle').hide();
}

$('#btn-store').on('click', function () {
    activateStore(true);
});
$('#btn-address').on('click', function () {
    activateAddress(false);
});

/**
 * Funcion para activar la seccion de seleccion por direccion.
 *@param {bool} actionFromButton saber si la peticion viene desde el boton buscar de la seccion de buscar por tienda, cd, etc
 */
function codeAddress(actionFromButton) {
    firstTime = false;
    if ($('#input-store-name').val() == '') {
        geocoder = new google.maps.Geocoder();
        var address;
        var alcaldia = document.getElementById('alcaldia').value;
        var country = document.getElementById('select-country');
        var selectState = document.getElementById('select-state');
        if (country.value == 'guatemala') {
            address = `${country.value} ${selectState.value} ${alcaldia}`;
        } else {
            address = `${country.value} ${selectState.options[selectState.selectedIndex].text} ${alcaldia}`;
        }
        fromCountry = true;
        if(country.value == 'mexico' && selectState.options[selectState.selectedIndex].text.toLowerCase().includes('selecciona') && !alcaldia) {
            onlyCountry = true;
            countryName = country.value;
            address = countryName
        } else if (country.value == 'guatemala' && selectState.value == '' && !alcaldia) {
            onlyCountry = true;
            countryName = country.value;
            radioGuat = true;
        }
        if(country.value && (selectState && selectState.options && !selectState.options[selectState.selectedIndex].text.toLowerCase().includes('selecciona')) && !alcaldia){
            searchOnlyState = true;
            stateName = selectState.options[selectState.selectedIndex].text.toLowerCase();
        }
        geocoder.geocode({ address: address }, function (results, status) {
            if (status == 'OK') {
                // Limpiar marcadores anteriores
                clearStoreMarkers();

                if (centerMarker) {
                    centerMarker.setMap(null);
                }
                if (searchCircle) {
                    updateSearchCircle(null, null, null, true);
                }
                alreadySearchGoogleInput = false;
                firstTime = false;
                getStores(results[0].geometry.location, getTypeReq(), true);
                try {
                    map.setCenter(results[0].geometry.location);
                } catch (error) {
                    map = new google.maps.Map(document.getElementById('map'), {
                        center: results[0].geometry.location
                    });
                }
            }
            onlyCountry = null;
            countryName = null;
            radioGuat = null;
            searchOnlyState = null;
            stateName = null
            searchPrevInCountrySection = true;
        });
    } else if (actionFromButton && $('#input-store-name').val()) {
        let queryStoreName = $('#input-store-name').val();
        let allSearch = {
            lat: 24.19062908764244,
            lng: -102.85224768231377
        };
        fromCountry = true;
        searchPrevInCountrySection = true;
        alreadySearchGoogleInput = false;
        firstTime = false;
        getStores(allSearch, getTypeReq(), true, queryStoreName);
        updateSearchCircle(null, null, null, true);
    }
}
// Selecciona todos los botones
const buttons = document.querySelectorAll(
    '.button-search-store, .button-search-cedis, .button-search-all'
);
// Agrega un event listener para cada botón
buttons.forEach((button) => {
    button.addEventListener('click', function () {
        // Remueve la clase 'active' y agrega 'color-change' de todos los botones
        buttons.forEach((btn) => {
            btn.classList.remove('active');
            btn.classList.add('color-change');
        });

        // Agrega la clase 'active' y remueve 'color-change' al botón actual
        this.classList.add('active');
        this.classList.remove('color-change');

        // Selecciona todos los botones con la misma clase que el botón actual
        const sameClassButtons = document.querySelectorAll(
            `.${this.classList[0]}`
        );

        // Aplica los estilos necesarios a esos botones
        sameClassButtons.forEach((btnSame) => {
            btnSame.classList.add('active');
            btnSame.classList.remove('color-change');
        });
        let typeStore = this.dataset.type;
        if (!$('#autocomplete').val() && !firstTime && searchPrevInCountrySection && !fromCountry) {
            $('#errorMessageInputGoogle').show();
            return;
        }
        clearStoreMarkers();
        if (centerMarker) {
            centerMarker.setMap(null);
        }
        if (fromCountry) {
            codeAddress(true);
        } else {
            getStores(
                globalLocation,
                typeStore,
                place ? null : true,
                null,
                geoActive
            );
        }
    });
});

// Funcionamiento del slider
const slider = document.getElementById('kmSlider');
const initialValue = document.getElementById('initialValue').value;
const currentValueSpan = document.getElementById('currentValue');
// Establece el valor del slider al valor deseado cuando carga la página
slider.value = initialValue;
// Actualiza el valor mostrado cuando el usuario mueve el slider
slider.addEventListener('input', function () {
    const value = slider.value;
    currentValueSpan.textContent = `${value} km`;
});

// Llama a la función getStores cuando el usuario suelta el slider
slider.addEventListener('change', function () {
    const valueInputGoogle = document.getElementById('autocomplete')
    if (valueInputGoogle && valueInputGoogle.value && valueInputGoogle.value !== ''){
        if (place && !valueInputGoogle.value) {
            searchByInputGoogle();
        } else if (valueInputGoogle.value) {
            searchByInputGoogle(valueInputGoogle.value);
        }
    }
});

let search = document.getElementById('search-country-search');
search.addEventListener('click', () => {
    // Llama a codeAddress con los parámetros necesarios
    codeAddress(true);
});
let inputSerach = document.querySelectorAll('.input-search-google');
inputSerach.forEach(searchInput => {
    searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            codeAddress(true);
        }
    });
})

/**
 * Manejo de seleccion de estado en el input tipo select
 */
function handleEstadoChange() {
    let urlReq = $('#get-municipios').val();
    let valueEstado = $('#select-state').val();
    let separator = urlReq.includes('?') ? '&' : '?';
    // Concatenar el parámetro 'estado' a la URL
    let newUrlReq = urlReq + separator + 'estado=' + encodeURIComponent(valueEstado);
    $.ajax({
        url: newUrlReq,
        type: 'GET',
        success: function (response) {
            var alcaldia = $('#alcaldia');
            let municipios = response.municipios;
            alcaldia.empty(); // Limpiar las opciones existentes
            alcaldia.append(
                '<option value="" disabled selected>Selecciona un municipio</option>'
            ); // Opción por defecto

            $.each(municipios, function (index, item) {
                alcaldia.append(
                    $('<option>', {
                        value: item.municipality,
                        text: item.municipality
                    })
                );
            });
        },
        error: function (error) {}
    });

    $('#input-store-name').val('');
}

// Selecciona el elemento <select> por su ID
var selectCountry2 = $('#select-country');
var container = $(document);

// Utilizamos la delegación de eventos para manejar los eventos en los elementos reemplazados
container.on('focus', '#alcaldia', function () {
    $('#input-store-name').val('');
});

container.on('change', '#alcaldia', function () {
    $('#input-store-name').val('');
});

selectCountry2.on('change', function () {
    $('#input-store-name').val('');
    if (selectCountry2.val() === 'mexico') {
        $('#select-state').replaceWith('<select id="select-state" class="input-search-google form-control select-custom"></select>');
        $('#alcaldia').replaceWith('<select id="alcaldia" class="input-search-google form-control select-custom"></select>');
        var estadosUrl = $('#get-estados').val();
        $.ajax({
            url: estadosUrl,
            type: 'GET',
            success: function (response) {
                var selectState = $('#select-state');
                let estados = JSON.parse(response.entidadesFederativas);
                selectState.empty(); // Limpiar las opciones existentes
                selectState.append(
                    '<option value="" disabled selected>Selecciona un estado</option>'
                ); // Opción por defecto

                $.each(estados, function (index, item) {
                    selectState.append(
                        $('<option>', {
                            value: item.ENTFEDNUM,
                            text: item.NOMBRE
                        })
                    );
                });
                // Volver a adjuntar el evento change al nuevo elemento <select>
                selectState.on('change', function() {
                    handleEstadoChange();
                });
            },
            error: function (error) {}
        });
    } else if ($('#select-state').length > 0) {
        $('#select-state').replaceWith('<input type="text" id="select-state" class="input-search-google w-100 form-control" placeholder="">');
        $('#alcaldia').replaceWith('<input type="text" id="alcaldia" class="input-search-google w-100 form-control" placeholder="">');
    }
});

/**
 * Funcion para mejorar scroll en navegador
 */
function adjustInfoWindowScroll() {
    // Ajustar la posición del scroll de la página para que el InfoWindow sea visible
    const infoWindowElement = document.querySelector('.gm-style-iw');
    if (infoWindowElement) {
        const boundingRect = infoWindowElement.getBoundingClientRect();
        const scrollOffset = boundingRect.top - (window.innerHeight / 2) + (boundingRect.height / 2);
        window.scrollTo({
            top: window.scrollY + scrollOffset,
            behavior: 'smooth'
        });
    } else {
        map = document.getElementById('map');
        if(map){
            const boundingRect = map.getBoundingClientRect();
            const scrollOffset = boundingRect.top - (window.innerHeight / 2) + (boundingRect.height / 2);
            window.scrollTo({
                top: window.scrollY + scrollOffset,
                behavior: 'smooth'
            });
        }
    }
}

/**
 * Funcion para analizar url de street view
 *@param {string} url - Original url
 *@returns {Object} return Parametro de url como latitude y longitude
 */
function parseStreetViewUrl(url) {
    const urlObj = new URL(url);
    const pathParts = urlObj.pathname.split('@');
    let latLng;
    let existLess;
    
    if (pathParts.length > 1) {
        const params = pathParts[1].split(',').map(param => decodeURIComponent(param.trim()));
        let long = params && params[1];
        if(long) {
            existLess = long.trim().includes('-');
        }
        if(!existLess) {
            long = '-' + params[1].trim();
        }
        // let long = '-' + params[1].trim();
        latLng = {
            lat: parseFloat(params[0]),
            lng: parseFloat(long.trim())
        };
    }

    return latLng;
}

// Función para mostrar Recorrido de la tienda
window.showStoreUrl360 = function showStoreUrl360(storeUrl360) {
    const mapDiv = document.getElementById('map');
    const panoData = parseStreetViewUrl(storeUrl360);
    const panorama = new google.maps.StreetViewPanorama(mapDiv, {
        position: { lat: panoData.lat, lng: panoData.lng },
        pov: {
            heading: 70,
            pitch: 11
        },
        zoom: 0,
        visible: true
    });

    // Mostrar Street View en el mapa
    mapDiv.style.display = 'block'; // Asegurar que el mapa sea visible
    try {
        map.setStreetView(panorama);
    } catch (error) {
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 5,
            center: globalLocation
        });
        map.setStreetView(panorama);
    }

    document.getElementById('exit-street-view').style.display = 'block';
    adjustInfoWindowScroll();
};

// Función para mostrar Street View
window.showStreetView = function showStreetView(lat, lng, storeUrlStreet) {
    const mapDiv = document.getElementById('map');
    let panorama;

    if (storeUrlStreet && storeUrlStreet !== "null") {
        const panoData = parseStreetViewUrl(storeUrlStreet);
        // Si existe un URL de Street View en los datos, abrirlo en el mapa existente
        if(panoData && panoData.lat && panoData.lng) {
            panorama = new google.maps.StreetViewPanorama(mapDiv, {
                position: { lat: panoData.lat, lng: panoData.lng },
                pov: {
                    heading: 34,
                    pitch: 10
                },
                zoom: 1
            });
        }else {
            panorama = new google.maps.StreetViewPanorama(mapDiv, {
                position: { lat: lat, lng: lng },
                pov: {
                    heading: 34,
                    pitch: 10
                },
                zoom: 1
            });
        }
    } else {
        // Si no hay URL de Street View, crear el panorama dinámicamente
        panorama = new google.maps.StreetViewPanorama(mapDiv, {
            position: { lat: lat, lng: lng },
            pov: {
                heading: 34,
                pitch: 10
            },
            zoom: 1
        });
    }

    // Mostrar Street View en el mapa
    mapDiv.style.display = 'block'; // Asegurar que el mapa sea visible
    
    try {
        map.setStreetView(panorama);
    } catch (error) {
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 5,
            center: globalLocation
        });
        map.setStreetView(panorama);
    }

    document.getElementById('exit-street-view').style.display = 'block';
    adjustInfoWindowScroll();
};

// Asignar la función al botón
let a = document.getElementById('exit-street-view');
a.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    exitStreetView();
});

const clearAll = document.querySelectorAll('.text-clear-all');

clearAll.forEach(clearText => {
    clearText.addEventListener('click', function () {
        $('body').spinner().start();
        $('#autocomplete').val("");
        $('#select-country').val('mexico').change();
        $('#alcaldia').val("");
        $('#input-store-name').val("");
        // Restablecer el slider
        slider.value = initialValue;
        currentValueSpan.textContent = `${initialValue} km`;
        place = null;
        clearAllBtn = true;
        fromCountry = false;
        initMap();
        setTimeout(()=>{
            $.spinner().stop();
        }, 900)
    });
});

window.showInfoWindow = function showInfoWindow(
    name,
    address1,
    numExt,
    numInt,
    postalCode,
    horarioTienda,
    telefonos,
    latitude,
    longitude,
    colonia,
    city,
    state,
    storeUrl360,
    storeUrlStreet
) {
    $('body').spinner().start();
    let contentString = `
            <div class="card-container-stores mb-4">
                <h3 class="card-cointainer__title pt-2 pb-2 pl-2">${name}</h3>
                <div class="card-container__body d-flex flex-column pl-2">
                    <p>${address1} ${numExt && numExt !== 'null' ? '#' + numExt : ''} ${numInt && numInt !== 'null' ? numInt : ''} ${colonia && colonia !== "null" ? colonia : ""} C.P ${postalCode} ${city ? city : ""}, ${state && state !== "undefined"? state : ""}</p>
                    <p>${horarioTienda && horarioTienda !== 'null' ? horarioTienda : ''} ${telefonos && telefonos !== 'null' ? telefonos : ''}</p>
                    <div class="body-container-locations d-flex justify-content-end">
                        <div class="body-container-locations__links d-flex flex-nowrap flex-sm-wrap justify-content-sm-end flex-md-nowrap">
                            <a href="javascript:void(0)" class="link-gray mr-2 mr-sm-0 mr-md-2" onclick="showStreetView(${latitude}, ${longitude}, &quot;${storeUrlStreet}&quot;)">Street view</a>
                            <a href="javascript:void(0)" class="link-blue ${storeUrl360 && storeUrl360 !== 'null' ? '' : 'd-none'}" onclick="showStoreUrl360(&quot;${storeUrl360}&quot;)">Recorre la tienda</a>
                        </div>
                    </div>
                    <div class="direction-container mt-2">
                        <div class="transport-options d-flex justify-content-around">
                            <label class="transport-option">
                                <input type="radio" name="transport-mode" value="DRIVING" checked>
                                <span class="material-symbols-outlined" data-mode="DRIVING">directions_car</span>
                            </label>
                            <label class="transport-option">
                                <input type="radio" name="transport-mode" value="WALKING">
                                <span class="material-symbols-outlined" data-mode="WALKING">directions_walk</span>
                            </label>
                            <label class="transport-option">
                                <input type="radio" name="transport-mode" value="TRANSIT">
                                <span class="material-symbols-outlined" data-mode="TRANSIT">directions_bus</span>
                            </label>
                            <label class="transport-option">
                                <input type="radio" name="transport-mode" value="BICYCLING">
                                <span class="material-symbols-outlined" data-mode="BICYCLING">directions_bike</span>
                            </label>
                        </div>
                        <div class="origin-destination w-100 d-flex content-justify-center">
                            <div class="icons-to-go d-flex flex-column">
                                <span class="material-symbols-outlined">
                                    trip_origin
                                </span>
                                <span class="material-symbols-outlined">
                                    go_to_line
                                </span>
                                <span class="material-symbols-outlined">
                                    location_on
                                </span>
                            </div>
                            <div class="input-container d-flex flex-column w-100">
                                <input type="text" id="origin-input" class="input-origin mb-1" placeholder="Origen">
                                <input type="text" id="destination-input" class="input-origin mt-1" value="${name} - ${address1}" readonly>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

    // Detectar si hay streetview abierto
    let elementStreetview = document.getElementById('exit-street-view')
    if(elementStreetview.style.display === 'block') {
        exitStreetView();
    }

    const position = new google.maps.LatLng(latitude, longitude);

    // Cerrar el InfoWindow actual si existe
    if (currentInfoWindow) {
        currentInfoWindow.close();
    }

    // Crear nuevo InfoWindow
    currentInfoWindow = new google.maps.InfoWindow({
        content: contentString,
        position: position,
        pixelOffset: new google.maps.Size(0, -40) // Ajusta el valor según sea necesario
    });

    // Centrar y hacer zoom en la ubicación del marcador
    try {
        map.setCenter(position);
        map.setZoom(15); // Ajusta el nivel de zoom según sea necesario
    } catch (error) {
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 15,
            center: position
        });
    }

    // Abrir el nuevo InfoWindow
    currentInfoWindow.open(map);

    // Inicializar Autocomplete después de que el contenido del InfoWindow esté disponible en el DOM
    setTimeout(() => {
        let originInput = document.getElementById('origin-input');
        autocompleteInfoWindow = new google.maps.places.Autocomplete(
            originInput
        );
        autocompleteInfoWindow.addListener('place_changed', () =>
            initInputPlacesInfoWindow(latitude, longitude)
        );
        const element = document.querySelector('.gm-style-iw-d');
        if (element) {
            const maxHeight = element.style.maxHeight;
            if (maxHeight) {
                element.style.maxHeight = '';
                element.style.height = '300px';
            }
        }
        adjustInfoWindowScroll();
        $.spinner().stop()
    }, 500);
};

/**
 * Funcion que inicializa mapa y demas atributos necesarios
 */
function initMain () {
    /**
     * 
     * @param {*} url url del archivo a cargar
     * @param {*} callback callback para cargar la data
     */
    function loadScript(url, callback) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        // Adjuntar eventos de carga
        script.onload = function () {
            callback();
        };

        // Agregar el script al head
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    /**
    * Funcion que inicializa los clusters
    */
    function initializeMarkerClusterer() {
        $('.button-search-store').each(function () {
            $(this).addClass('active');
            $(this).removeClass('color-change');
        });
        initMap();
        activateAddress();

        // Asegurarse de que el evento change esté adjuntado al elemento correcto
        if (selectCountry2.val() === 'mexico') {
            $('#select-state').on('change', function() {
                handleEstadoChange();
            });
        }
        // Crear el MarkerClusterer y asignarlo a una variable global
        // window.markerCluster = new markerClusterer.MarkerClusterer({ map, storeMarkers });
        markerCluster = new markerClusterer.MarkerClusterer({ map, storeMarkers });
    }

    // Cargar el script de MarkerClusterer y luego inicializar
    loadScript('https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js', initializeMarkerClusterer);
}

$(document).ready(function () {
    initMain();
});
